import { createSHA256 } from "hash-wasm";

export async function calculateFileSha256(
  file: File,
  chunkSize: number = 2 * 1024 * 1024,
): Promise<string> {
  const hasher = await createSHA256();
  let offset = 0;

  while (offset < file.size) {
    // eslint-disable-next-line no-await-in-loop -- necessário para processar o arquivo sequencialmente em blocos para cálculo de hash incremental
    const chunk = await file.slice(offset, offset + chunkSize).arrayBuffer();
    hasher.update(new Uint8Array(chunk));
    offset += chunkSize;
  }

  return hasher.digest("hex");
}
